import { useEffect, useState } from 'react';

import { revendedoresTheme, eudoraTheme, globalCss } from '@grupoboticario/flora';
import { FloraProvider as Provider } from '@grupoboticario/flora-react';

import { useGlobalContext } from 'store';

const globalStyles = globalCss({
  'html, body, html > body': {
    background: '$backgroundSecondary',
  },
});

globalStyles();

const theme: { [key: string]: typeof revendedoresTheme } = {
  boticario: revendedoresTheme,
  eudora: eudoraTheme,
};

const pathsToResetCSS = ['/departamentos'];

const appPathsToResetCss = () => !pathsToResetCSS.some((path) => path === window.location.pathname);

export const FloraProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}): JSX.Element => {
  const { brand } = useGlobalContext();
  const [resetCss, setResetCss] = useState(appPathsToResetCss());

  useEffect(() => {
    setResetCss(appPathsToResetCss());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  return (
    <Provider theme={theme[brand.short]} resetCSS={resetCss}>
      {children}
    </Provider>
  );
};
